import { ChecklistItem } from './../builders/checklist_item_builder';
import { SelectionListServant } from './../../global/servants/selection_list_servant';
import { IChecklistItemsDatasource } from './../datasources/checklist_items_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-checklist').factory(
  'selectChecklistItemCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngSelectionListServant: SelectionListServant,
    ngChecklistItemsDatasource: IChecklistItemsDatasource
  ): ICommand => {
    return defineCommand(
      'selectChecklistItemCommand',
      (deferred: ng.IDeferred<IQuery[]>, item: ChecklistItem): void => {
        const selectItem = ngChecklistItemsDatasource.get(item.id);
        if (!_.isUndefined(selectItem)) {
          ngSelectionListServant.replaceSelect(ngChecklistItemsDatasource.model.checklistSelection, selectItem!);
        }
        deferred.resolve(QueryMediator.runQueries(ngChecklistItemsDatasource));
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/lib/checklist/commands/select_checklist_item_command.ts